import { jsx as _jsx } from "react/jsx-runtime";
import '@/styles/Characters/InlineEditField.css';
import { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
const InlineEditMultiSelect = ({ name, values = [], options, placeholder, onChange, isDisabled, classNamePrefix = 'react-select', className, }) => {
    const [editing, setEditing] = useState(false);
    const wrapperRef = useRef(null);
    const selectedOptions = options.filter((o) => values.includes(o.value));
    useEffect(() => {
        function handleClickOutside(e) {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setEditing(false);
            }
        }
        if (editing)
            document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [editing]);
    const handleSelectChange = (opts) => {
        onChange(opts.map((o) => o.value));
    };
    if (editing && !isDisabled) {
        return (_jsx("div", { ref: wrapperRef, className: `inline-edit-select-wrapper ${className || ''}`, onMouseDown: (e) => e.stopPropagation(), children: _jsx(Select, { name: name, isMulti: true, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                value: selectedOptions, options: options, closeMenuOnSelect: false, hideSelectedOptions: true, onChange: (opts) => handleSelectChange(opts), placeholder: placeholder, isSearchable: false, classNamePrefix: classNamePrefix, onBlur: () => setEditing(false), onMenuClose: () => setEditing(false) }) }));
    }
    return (_jsx("span", { className: `inline-edit-display ${className || ''}`, role: "button", tabIndex: 0, "aria-label": placeholder, onClick: isDisabled
            ? undefined
            : (e) => {
                e.stopPropagation();
                setEditing(true);
            }, onKeyDown: (e) => {
            if (isDisabled)
                return;
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setEditing(true);
            }
        }, title: placeholder, children: selectedOptions.length ? (selectedOptions.map((o) => o.label).join(', ')) : (_jsx("span", { className: "inline-edit-placeholder", children: placeholder })) }));
};
export default InlineEditMultiSelect;
